import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var PayoutNotReceivedIA = function PayoutNotReceivedIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Vlx7bU",
    defaultMessage: "If you\u2019re experiencing a delay in receiving your payout, it\u2019s essential to verify a few key details about your order and account settings to understand why. Here\u2019s what to check:"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "L8yZ/q",
    defaultMessage: "<BoldFormatting>Order Status:</BoldFormatting> Your order must be marked as \"Shipped\" to trigger a payout. Ensure you\u2019ve entered shipment tracking information so that the status is accurate.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bNsRBC",
    defaultMessage: "<BoldFormatting>Payout Options:</BoldFormatting> Review the <LinkFormatting>payout terms</LinkFormatting> you\u2019ve selected. Payment will be initiated up to 60 days after shipment, depending on the terms you choose. It typically takes  3-5 business days to reflect in your account, depending on your bank\u2019s processing time.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "KumpfT",
    defaultMessage: "<BoldFormatting>Bank Account Information:</BoldFormatting> Double check that your bank account details are accurate and up-to-date. Incorrect information can lead to payout delays.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hLc85/",
    defaultMessage: '<BoldFormatting>Preorders:</BoldFormatting> For preorders, both Payout and Ship dates might be listed as "Unknown" until the preorder fulfillment is complete. Please wait for these orders to be fulfilled before expecting a payout.',
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};